<template>
    <div class="device-type-manange relative">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane :label="'完成会面数量('+reservationed_number+')'" name="1">
                <part1 ref="p1" :allType="allType"></part1>
            </el-tab-pane>
            <el-tab-pane :label="'会面中断数量('+reservationed_faile_number+')'" name="2">
                <part2 ref="p2" :allType="allType"></part2>
            </el-tab-pane>
        </el-tabs>


        <!-- 表单开始 -->
        
    </div>
</template>
<script>
    import {getUserInfos} from '@/utils/userInfos'
    import {getFormatDate} from "@/utils/date";
    import {check} from "@/utils/checkData";
    import part1 from "./WorkListPart.vue";
    import part2 from "./WorkListPart.vue";

    export default {

         components: {
                part1,
                part2,
            },

        data() {
            return {
                reservationed_number: 0,
                reservationed_faile_number: 0,
                allType: [],
                tableData: [],
                activeName: '1',

            };
        },
        mounted() {
            // window

            //this.getList();
            this.getAllReservationStatusNumber();
            this.subWindow('p1',3);
            this.subWindow('p2',4);



        },
        methods: {
            // 所有状态的预约数量
            getAllReservationStatusNumber() {
                let params = {
                    servername: 'Ruyi_AdminWorkbenchServices',
                    method: 'allReservationStatusNumber',
                    params: {
                        status: [3, 4],
                    },
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }

                    if (res.data.data && res.data.data.length > 0) {
                        for (var i = 0; i < res.data.data.length; i++) {

                            switch (res.data.data[i].status) {
                                case '3':
                                    this.reservationed_number = res.data.data[i].number;
                                    break;
                                case '4':
                                    this.reservationed_faile_number = res.data.data[i].number;
                                    break;
                            }
                        }
                    }
                    this.allType = res.data.data;
                });
            },
            subWindow(w_name,status)
            {
                this.$refs[w_name].getList(status);
            },


            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },

            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },
            // 创建预约
            addWork() {
                this.$router.push({name: "workAdd", params: {}});
            },

            // 跳转添加页
            addHospitalType() {
                this.$router.push({name: "articleAdd", params: {}});
            },

             handleClick(tab, event) {
                // console.log(this.activeName)
            }

        },

    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";
    .el-tabs__nav .is-active{
        position: relative;
    }
    .el-tabs__nav .is-active::after{
        content: "";
        position: absolute;
        bottom: 3px;
        left: 15px;
        width: 82%;
        height: 2px;
        background-color: #409EFF;

    }
</style>
